<template> </template>

<script>
export default {
  name: "depot-edit"
};
</script>
